import { AdditionalColumnCellProps } from "PFApp/activities/manage_roles/parts/additional_column_cell/additional_column_cell.types";
import { Stack } from "PFComponents/containers";
import { useWatch } from "react-hook-form";

import css from "../cell.module.scss";

const STATISTICS_KEY = "statistics";
const COOWNED_KEY = "coowned";

export const VacanciesAdditionalColumnCell = ({
  column,
  rolesFormKey,
  renderCell,
  info
}: AdditionalColumnCellProps) => {
  const statisticsPath = `${rolesFormKey}.${info.row.index}.original.${STATISTICS_KEY}`;
  const coownedPath = `${rolesFormKey}.${info.row.index}.original.${COOWNED_KEY}`;

  const statistics = useWatch({ name: statisticsPath });
  const coowned = useWatch({ name: coownedPath });

  const row = {
    original: {
      activity: {
        [COOWNED_KEY]: coowned,
        [STATISTICS_KEY]: statistics
      }
    }
  };

  return <Stack className={css.cell}>{renderCell(column)({ ...info, row })}</Stack>;
};
